// 阶段测试问卷优惠券列表
const couponList = [
  {
    path: 'pages/market/couponbag/index?id=600143&refer=coupon-package&storeId=2494001455&acquireChannelId=600143'
  },
  {
    path: 'pages/market/couponbag/index?id=600144&refer=coupon-package&storeId=2494001455&acquireChannelId=600144'
  },
  {
    path: 'pages/market/couponbag/index?id=600145&refer=coupon-package&storeId=2494001455&acquireChannelId=600145'
  },

  {
    path: 'pages/market/couponbag/index?id=600148&refer=coupon-package&storeId=2494001455&acquireChannelId=600148'
  },
  {
    path: 'pages/market/couponbag/index?id=600149&refer=coupon-package&storeId=2494001455&acquireChannelId=600149'
  },
  {
    path: 'pages/market/couponbag/index?id=600150&refer=coupon-package&storeId=2494001455&acquireChannelId=600150'
  },
  {
    path: 'pages/market/couponbag/index?id=600151&refer=coupon-package&storeId=2494001455&acquireChannelId=600151'
  },
  {
    path: 'pages/market/couponbag/index?id=600152&refer=coupon-package&storeId=2494001455&acquireChannelId=600152'
  },
  {
    path: 'pages/market/couponbag/index?id=600153&refer=coupon-package&storeId=2494001455&acquireChannelId=600153'
  },
  {
    path: 'pages/market/couponbag/index?id=600154&refer=coupon-package&storeId=2494001455&acquireChannelId=600154'
  },
  {
    path: 'pages/market/couponbag/index?id=600155&refer=coupon-package&storeId=2494001455&acquireChannelId=600155'
  },
  {
    path: 'pages/market/couponbag/index?id=600156&refer=coupon-package&storeId=2494001455&acquireChannelId=600156'
  }
]
export { couponList }
